import React, { useState, useMemo } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { cart__items } from '../../data/StaticDatas';
import OrderIcon from '../../assets/OrderConfirm.svg';
import DeliveryIcon from '../../assets/DeliveryIcon.svg';
import LocationIcon from '../../assets/LocationIcon.svg';
import Dot from '../../assets/dot.svg'
import AppModal from '../Modal/AppModal';
import CheckCircle from '../../assets/GiftAsset/CheckCircle.svg'
import { useNavigate, useParams } from 'react-router-dom';
import { usePost } from '../../hooks/useApi';
import { handleConfirmOrder } from '../../services/api';
import { useLocation } from 'react-router-dom';
const ProductOrder = ({title, price,orderItem }) => {
    const navigate = useNavigate()
    const location = useLocation(); // Get current location (including query params)
  const queryParams = new URLSearchParams(location.search); // Create URLSearchParams object
    const messageContent = {
        beforeSpan: "Thank you for choosing",
        spanContent: "",
        afterSpan: ""
      };
    const [formData, setFormData] = useState('')
    const [openModal, setOpenModal] = useState('')
    // const handleChange = ()=>{

    // }

    const { 
            data: orderConfirm, 
            error: orderErr, 
            isLoading: ordertLoader 
          } = usePost('api/GiftItemOrders/confirm-order?orderId=GFT44562983498');
        
        console.log(orderConfirm)
      const giftOrder = useMemo(() => orderConfirm?.data || [
      ], [orderConfirm]);
    const trackingId = queryParams.get('trackingId');
console.log(orderItem?.orderId)
const confirmOrderUrl = `https://daradservice.azurewebsites.net/api/GiftItemOrders/confirm-order?orderId=${orderItem?.orderId}`
console.log(confirmOrderUrl)
    const handleClick = ()=>{
        console.log(trackingId)
        console.log(confirmOrderUrl)
        console.log(orderItem?.orderId)

        handleConfirmOrder(confirmOrderUrl, setOpenModal)
    }
    const handleHomeClick = ()=>{
navigate('/')
    }
const handleShopClick = ()=>{
    navigate('/product/giftshop')
}

console.log(orderItem?.orderId)

    const single_item = cart__items[0]
const purchasedTime = new Date(orderItem?.datePurchased)
const pickedtime = new Date(orderItem?.datePurchased)
pickedtime.setHours(pickedtime.getHours() + 4);

console.log(pickedtime)
    console.log(orderItem)
  return (
    <Box>
        <Box sx={{border:'1px solid rgba(231, 231, 231, 1)', backgroundColor:'rgba(241, 240, 242, 1)',  borderRadius:'12px', p:1, mb:4, display:'flex', justifyContent:'space-between'}}>
            <Typography sx={{py:1}}>
                Tracking Number
            </Typography>
            <Typography sx={{display:'flex', justifyContent:'space-between',px:2, py:1}}>
                {orderItem?.trackingOrderId}
            </Typography>
        </Box>
        <Box sx={{my:2, backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(182, 183, 185, 1)', p:2, borderRadius:'16px'}}>
            <Typography variant='h6' sx={{mb:2}}>
                Oder Items
            </Typography>
            <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <Box sx={{display:'flex', alignItems:'center', gap:2}}>
                    <img src={orderItem?.imageUrl!==''?orderItem?.imageUrl:single_item.images[0]} alt="item image" style={{width:'100px', height:'70px'}}/>
                    <Typography>
                        {orderItem?.productName}
                    </Typography>
                </Box>
                <Typography>
                    {orderItem?.quantity}
                </Typography>
            </Box>
        </Box>
        <Box sx={{border:'1px solid rgba(231, 231, 231, 1)', backgroundColor:'rgba(255, 255, 255, 1)', borderRadius:'12px', my:4, py:3}}>
            <Typography variant='h5' sx={{display:'flex', justifyContent:'space-between',p:2}}>
                Where is My Order
            </Typography>
            <Box sx={{display:'flex', gap:{xs:4, md:2}, alignItems:'center',p:'0 1rem 0 1rem'}}>
                <Box sx={{width:'10%'}}>
                    <img src={OrderIcon} alt="" />
                </Box>
                <Box sx={{width:'90%'}}>
                    <Typography variant='h6' color='rgba(10, 10, 10, 0.8)' sx={{fontSize:'1rem'}}>
                        Order Confirmed
                    </Typography>
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', color:'rgba(140, 142, 152, 1)'}}>
                        <Typography style={{width: '80%', fontSize:'.8rem'}}>
                            Your order is being processed
                        </Typography>
                        <Typography style={{display:'flex', alignItems:'center', gap:5, width:'20%', fontSize:'.8rem'}}>
                            <img src={Dot} alt="dot" />
                            <span>
                                {purchasedTime .toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    })}
                            </span>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={{display:'flex', justifyContent:'center', width:'80px'}}>
                <Box sx={{height:'50px', borderLeft:'2px solid rgba(203, 177, 252, 1)'}}>

                </Box>
            </Box>
            <Box sx={{display:'flex', gap:{xs:4, md:1}, alignItems:'center',p:'0 1rem 0 1rem'}}>
                <Box sx={{width:'10%'}}>
                    <img src={DeliveryIcon} alt="" />
                </Box>
                <Box sx={{width:'90%'}}>
                    <Typography variant='h6' color='rgba(10, 10, 10, 0.8)' sx={{fontSize:'1rem'}}>
                        Delivery Agent Picks your Order
                    </Typography>
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', color:'rgba(140, 142, 152, 1)'}}>
                        <Typography style={{width: '80%', fontSize:'.8rem'}}>
                            Delivery agent is on the way
                        </Typography>
                        <Typography style={{display:'flex', alignItems:'center', gap:5, width:'20%', fontSize:'.8rem'}}>
                            <img src={Dot} alt="dot" />
                            <span>
                            {pickedtime .toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    })}
                            </span>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={{display:'flex', justifyContent:'center', width:'80px'}}>
                <Box sx={{height:'50px', borderLeft:'2px solid rgba(203, 177, 252, 1)'}}>

                </Box>
            </Box>
            <Box sx={{display:'flex', gap:{xs:4, md:1}, alignItems:'center',p:'0 1rem 0 1rem'}}>
                <Box sx={{width:'10%'}}>
                    <img src={LocationIcon} alt="" />
                </Box>
                <Box sx={{width:'90%'}}>
                    <Typography variant='h6' color='rgba(10, 10, 10, 0.8)' sx={{fontSize:'1rem'}}>
                        {'12, oshinteye street ,off dumirun road , agboyi road ketu lagos nigeru'.slice(0, 40)}...
                    </Typography>
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', color:'rgba(140, 142, 152, 1)'}}>
                        <Typography style={{width: '80%', fontSize:'.8rem'}}>
                            Delivery 
                        </Typography>
                        <Typography style={{display:'flex', alignItems:'center', gap:5, width:'20%', fontSize:'.8rem'}}>
                            <img src={Dot} alt="dot" />
                            <span>
                            {pickedtime .toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    })}
                            </span>
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
        <Box sx={{ mt:6}}>
        <Button variant="contained"
        onClick={handleClick}
                  sx={{width:'100%', my:3,display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', p:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}>Confirm You Recieved Package</Button>
        </Box>
        {openModal && <AppModal setShowModal={setOpenModal} showModal={openModal} icon={CheckCircle}  message={messageContent}>
        <Typography sx={{color: '#4f03e7', fontSize: 20}}>
        MyDarads.
            </Typography>
            <Typography variant='p' sx={{marginTop: 2}}>
            Your order has been successfully confirmed! 
            </Typography>
        <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'space-between', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%', gap: 6}}>



{/* Add to Favorites Button  */}
<Box sx={{ marginTop: 1,width: 'auto' }}>
 <Button
 onClick={handleShopClick}
   variant="contained"
   color="secondary"
   sx={{
     width: '100%',
     
     padding: {md: '10px 20px', xs: '5px 8px'},
     border: '1px solid #CBB1FC',
     borderRadius: '25px',
    
     textTransform:'capitalize',
      backgroundColor: '#5604F6',
       color:'#fff'
    
  
   }}
 >
   shop another product
 </Button>
</Box>



<Box sx={{ marginTop: 2, width: 'auto'}}>
 <Button
   variant="contained"
   color="success"
   onClick={handleHomeClick}
   sx={{
     width: '100%',
     padding: {md: '10px 20px', xs: '5px 8px'},
     borderRadius: '25px',
       textTransform:'capitalize',
       backgroundColor:'rgba(219, 219, 219, 1)',
     color:'rgba(18, 18, 18, 0.7)',
   }}
 >
   go to homepage
 </Button>
</Box>
</Box>
            
            </AppModal>}
    </Box>
  )
}

export default ProductOrder